(function(window, document, $, undefined){
  


  // -----------------------------------------------------------------------------------------------------
  // iLightbox
  // -----------------------------------------------------------------------------------------------------



  var iLightboxOptions = {
      skin:'flat-dark',
      // path: 'horizontal'
      // skin:'metro-white'
  };


  // make lightbox horizontal if its a mobile device
  if(mobileAndTabletcheck() && $('a[href$=".gif"], a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".bmp"], a.ilightbox').length>0) {
    iLightboxOptions.path = 'horizontal';
    // console.log('mobileAndTabletcheck',mobileAndTabletcheck());
    // $(window).on('resize',function(){
    //   iLightboxOptions.path = 'horizontal';
    // }).trigger('resize');
  }


  $('a[href$=".gif"], a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".bmp"], a.ilightbox').click(function(e) {
    e.preventDefault();
    var url = $(this).attr('href');
    // galleries
    // var galleryElement = $(this).closest('[class*="ilightbox-gallery"]').first();
    var galleryElement = $(this).parents('[class*="ilightbox-gallery"]').eq(0);

    if(galleryElement.length > 0) {
      // --- gallery ---
      var ilightboxUrls = [];
      var clickedIndex = 0;
      // find out if its per item, or in a div gallery
      var galleryElements = '';
      if ($(this) == galleryElement) { //if the thing we clicked is the gallery identifier (not parent div or something) 
        // ilightbox-gallery on individual images
        // get the gallery ref ID & class
        var myString = $(this).attr("class");
        var myRegexp = /ilightbox-gallery(?:-|)([a-z0-9]*)/g; //matches with group 1 being the ID if found
        var match = myRegexp.exec(myString);
        var ilightboxGalleryClass = '.'+match[0];
        var ilightboxGalleryRef = '.'+match[1];
        galleryElements = $(ilightboxGalleryClass);
      } else {
        // ilightbox-gallery on parent element
        galleryElements = $(galleryElement).find('a[href$=".gif"], a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".bmp"], a.ilightbox');
        // console.log('galleryElement',galleryElement);
        // console.log('galleryElements',galleryElements);
      }
      // build up the URL array
      $.each(galleryElements, function(index, val) {
        var galleryItemUrl = $(this).attr('href');
        if(galleryItemUrl == url) clickedIndex = index;
        ilightboxUrls.push({url:galleryItemUrl});
      });
    // console.log('galleryElements',galleryElements);
      // set the start index to what was clicked
      iLightboxOptions.startFrom = clickedIndex;
      // launch ilightbox
      $.iLightBox(ilightboxUrls,iLightboxOptions);
    } else {
      // --- single image ---
      $.iLightBox([{URL:url}],iLightboxOptions);
    }
  });

  // // images - puts all images found on page in gallery.
  // $('a[href$=".gif"], a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".bmp"], a.ilightbox').iLightBox(iLightboxOptions);



// before fl updates
  // var iLightboxOptions = {
  //     skin:'flat-dark'
  // }

  // $('a[href$=".gif"], a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".bmp"], a.ilightbox').click(function(e) {
  //   e.preventDefault();
  //   var url = $(this).attr('href');
  //   // galleries
  //   var galleryElement = $(this).closest('[class^="ilightbox-gallery"]');
  //   if(galleryElement[0]) {
  //     // --- gallery ---
  //     var ilightboxUrls = [];
  //     var clickedIndex = 0;
  //     // find out if its per item, or in a div gallery
  //     var gallerySelector = '';
  //     if ($(this)[0] == galleryElement[0]) { //if the thing we clicked is the gallery identifier (not parent div or something) 
  //       // ilightbox-gallery on individual images
  //       // get the gallery ref ID & class
  //       var myString = $(this).attr("class");
  //       var myRegexp = /ilightbox-gallery(?:-|)([a-z0-9]*)/g; //matches with group 1 being the ID if found
  //       var match = myRegexp.exec(myString);
  //       var ilightboxGalleryClass = '.'+match[0];
  //       var ilightboxGalleryRef = '.'+match[1];
  //       gallerySelector = $(ilightboxGalleryClass);
  //     } else {
  //       // ilightbox-gallery on parent element
  //       gallerySelector = $(galleryElement[0]).children('a[href$=".gif"], a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".bmp"], a.ilightbox');
  //     }
  //     console.log('gallerySelector',gallerySelector);
  //     // build up the URL array
  //     $.each(gallerySelector, function(index, val) {
  //       var galleryItemUrl = $(this).attr('href');
  //       if(galleryItemUrl == url) clickedIndex = index;
  //       ilightboxUrls.push({url:galleryItemUrl});
  //     });
  //     // set the start index to what was clicked
  //     iLightboxOptions.startFrom = clickedIndex;
  //     // launch ilightbox
  //     $.iLightBox(ilightboxUrls,iLightboxOptions);
  //   } else {
  //     // --- single image ---
  //     $.iLightBox([{URL:url}],iLightboxOptions);
  //   }
  // });

  // // images - puts all images found on page in gallery.
  // $('a[href$=".gif"], a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".bmp"], a.ilightbox').iLightBox(iLightboxOptions);


})(window, document, jQuery);
